import moment from 'moment';
import Poller from 'backbone-poller';

import { titleCase } from 'change-case';
import { handleResponseError } from 'utils/messages';

import CashFlowReport from 'app/models/cash_flow_report';
import PaymentLogReport from 'app/models/payment_log_report';
import ShipmentReport from 'app/models/shipment_report';
import TrackerReport from 'app/models/tracker_report';
import FulfillmentOrderReport from 'app/models/fulfillment_order_report';
import FulfillmentInventoryReport from 'app/models/fulfillment_inventory_report';
import FulfillmentThirdPartyFailedOrderReport from 'app/models/fulfillment_third_party_failed_order_report';

import LoaderView from 'app/views/loader_view';
import ReportDetailViewBase from 'app/views/report_detail_view_base';

import tmpl from './template';

export default ReportDetailViewBase.extend({
  compiledTemplate: tmpl,
  className: 'report-detail',


  events: {
    'click .download-report': 'downloadReport',
  },

  initialize(options) {
    this.reportType = options.reportType;
    this.reportId = options.reportId;
    this.mode = options.mode;

    const ReportModelClass = this.getReportModelClass(this.reportType);
    this.model = new ReportModelClass({ id: this.reportId, mode: this.mode });

    this.addSubview('reportLoader', '#report_loader', new LoaderView({}));
    this.addSubview('reportDownloadLoader', '#report_download_loader', new LoaderView({}));

    this.listenTo(this.model, 'sync error', this.render);

    this.poller = Poller.get(this.model, { delay: 3000 });
    this.poller.on('success', model => {
      const currentStatus = model.get('status');
      if (currentStatus === 'available' || currentStatus === 'failed') this.poller.stop();
    });
    this.poller.on('error', (model, resp) => {
      handleResponseError(resp, errMsg => {
        this.errMsg = errMsg;
        this.poller.stop();
      });
    });
    this.poller.start();
  },

  context() {
    const date = this.model.get('created_at');

    return {
      errMsg: this.errMsg,
      id: this.model.get('id'),
      reportType: this.reportType,
      reportTypeReadable: this.model.reportTypeReadable || titleCase(this.model.get('object')),
      createdAtDate: moment(date).format('YYYY-MM-DD'),
      createdAtTime: moment(date).format('hh:mma'),
      startDate: moment(this.model.get('start_date')).format('YYYY-MM-DD'),
      endDate: moment(this.model.get('end_date')).format('YYYY-MM-DD'),
      status: this.model.get('status'),
      url: this.model.get('url'), // This field should not be printed/used directly, since these urls expire very quickly
    };
  },

  getReportModelClass(type) {
    return {
      cash_flow: CashFlowReport,
      payment_log: PaymentLogReport,
      shipment: ShipmentReport,
      tracker: TrackerReport,
      fulfillment_order: FulfillmentOrderReport,
      fulfillment_inventory: FulfillmentInventoryReport,
      fulfillment_third_party_failed_order: FulfillmentThirdPartyFailedOrderReport,
    }[type];
  },

  remove() {
    this.poller.destroy();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/report_detail/index.js